import React from "react";
import { Expression, Operand } from "@merrie/nmbrs-api";
import { DisplayExpressionComponent } from "../display-epression/display-expression.component";
import { DisplayOperandComponent } from "../display-operand/display-operand.component";
import "./display.component.scss";

export interface IDisplayProperties {
  expression: Expression;
  operand: Operand;
  isEvaluated?: boolean;
}

export const DisplayComponent: React.FC<IDisplayProperties> = ({
  expression,
  isEvaluated,
  operand,
}) => (
  <div className={`display`}>
    <DisplayExpressionComponent
      expression={expression}
      operand={
        operand.manipulations.length > 0 && !isEvaluated ? operand : undefined
      }
      isEvaluated={isEvaluated}
    />
    <DisplayOperandComponent operand={operand} />
  </div>
);
